import createJobDefaultReducer from './createJobDefaultReducer';

export default (state = {}, action) => {
  return createJobDefaultReducer('EDITJOB', action, state);
};
